import { toast } from '@/shared/toast'
import { IconName } from '@/uiKit/IconName'
import { registerSW } from 'virtual:pwa-register'

const promptForUpdate = () =>
  toast.loading(
    'A new version of the app is available. Please refresh to update all your open tabs.',
    {
      duration: Infinity,
      id: 'pwa-update-toast',
      icon: IconName['gift-fill'],
      action: { label: 'Refresh', onClick: () => updateSW(true) },
    },
  )

const updateSW = registerSW({
  onRegisteredSW: async (swUrl, r) => {
    setInterval(async () => {
      // if users have too many go tabs open, having each tab check
      // might overwhelm their network and cause network issues
      if (document.visibilityState === 'hidden') return

      await r?.update()

      if (r?.waiting) {
        promptForUpdate()
      }
    }, 35_000)
  },
  onRegisterError(error) {
    // eslint-disable-next-line no-console
    console.error(error)
  },
})
